import { modals } from '@mantine/modals';

import { useDeleteShopMutation } from '../store/shops-api';
import { handleShopDeleteError } from '../utils/helpers/shops-errors';
import { useShowResponseStatus } from '@/shared';

import type { TShop } from '../store/types';

export const useDeleteShop = () => {
  const [deleteShop, { isLoading, isSuccess, error }] = useDeleteShopMutation();
  const deleteError = handleShopDeleteError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Магазин удалён',
    error: deleteError,
  });

  const openDeleteModal = (item: TShop) =>
    modals.openConfirmModal({
      title: `Удаление магазина c ID ${item.id}`,
      centered: true,
      children: `Вы точно хотите удалить магазин "${item.name}"?`,
      labels: { confirm: 'Удалить', cancel: 'Отмена' },
      confirmProps: { color: 'red' },
      onConfirm: async () => await deleteShop({ shopId: item.id }),
    });

  return {
    deleteShop,
    openDeleteModal,
    isLoading,
  };
};
